<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col
        cols="12"
        md="4"
      >
        <material-card
          title="Content"
          :loading="loadingSchemas"
          color="primary"
        >
          <profile-list
            :items="schemas"
            @select="getContent"
          />
          <template v-slot:actions>
            <build />
          </template>
        </material-card>
      </v-col>
      <v-col
        md="8"
        cols="12"
      >
        <material-card
          v-if="selectedSchema"
          color="primary"
          :loading="loadingContent"
        >
          <template v-slot:header>
            <div
              class="pa-3"
            >
              <h4
                class="title font-weight-light"
              >
                {{ selectedSchema.name }}
              </h4>
            </div>

            <v-spacer />
            <v-btn
              color="secondary"
              class="mr-3"
              @click="addContent"
            >
              <v-icon class="pr-3">
                mdi-plus
              </v-icon>Add Content
            </v-btn>
          </template>
          <profile-list
            :items="content"
            @delete="onContentDelete"
            @select="editContent"
          />
        </material-card>
      </v-col>
    </v-row>
    <v-dialog
      v-model="dialog"
      fullscreen
      scrollable
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <material-card
        v-if="selectedSchema"
        color="primary"
        :loading="uploadingImage"
      >
        <template v-slot:header>
          <v-btn
            icon
            color="secondary"
            class="ml-3"
            @click="dialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <div
            class="pa-3"
          >
            <h4
              class="title font-weight-light"
            >
              {{ selectedSchema.name }}
            </h4>
          </div>
          <v-spacer />
          <v-btn
            color="secondary"
            class="mr-3"
            :loading="addingContent"
            @click="saveContent"
          >
            <v-icon class="pr-3">
              mdi-floppy
            </v-icon>Save
          </v-btn>
        </template>
        <v-form
          ref="form"
          v-model="valid"
        >
          <v-row
            style="max-width: 1080px;"
            class="mx-auto"
            justify="center"
          >
            <v-col
              v-for="(field,i) in selectedSchema.fields"
              :key="i"
              cols="12"
            >
              <v-text-field
                v-if="field.type === 'text' || field.type === 'int' || field.type === 'decimal'"
                v-model="currentContent[field.name]"
                :label="capitalize(field.name)"
                :rules="field.required ? requiredRules : []"
                :type="field.type === 'int' ? 'number' : 'text'"
              />
              <v-checkbox
                v-if="field.type === 'boolean'"
                v-model="currentContent[field.name]"
                :label="capitalize(field.name)"
                :rules="field.required ? requiredRules : []"
              />
              <template v-if="field.type === 'html'">
                <h3 class="subtitle-1">
                  {{ capitalize(field.name) }}
                </h3>
                <vue-editor
                  :id="'editor-' + i"
                  v-model="currentContent[field.name]"
                  use-custom-image-handler
                  @image-added="handleImageAdded"
                />
              </template>
              <template v-if="field.type === 'image'">
                <v-file-input
                  v-model="image[field.name]"
                  accept="image/*"
                  show-size
                  :loading="uploadingImage"
                  :label="capitalize(field.name) + ' file'"
                  @change="() => uploadImage(field.name)"
                />
                <v-row
                  align="center"
                  class="mx-0"
                >
                  <v-divider class="mr-3" />Or<v-divider class="ml-3" />
                </v-row>
                <v-text-field
                  v-model="currentContent[field.name]"
                  :rules="field.required ? requiredRules : []"
                  :label="capitalize(field.name) + ' url'"
                />
              </template>
            </v-col>
            <v-col
              cols="12"
              class="text-right"
            >
              <v-btn
                color="primary"
                :loading="addingContent"
                @click="saveContent"
              >
                <v-icon class="pr-3">
                  mdi-floppy
                </v-icon>Save
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </material-card>
    </v-dialog>
    <yes-no-dialog
      ref="yesno"
      @yes="currentDelete"
    />
  </v-container>
</template>

<script>
  import moment from 'moment'
  import { VueEditor } from 'vue2-editor'
  import ProfileList from '../components/core/ProfileList.vue'
  import YesNoDialog from '../components/core/YesNoDialog.vue'
  import Build from '../components/core/Build.vue'
  export default {
    components: {
      ProfileList,
      Build,
      YesNoDialog,
      VueEditor
    },
    data () {
      return {
        schemas: [],
        valid: true,
        selectedSchema: null,
        requiredRules: [
          v => !!v || 'Required',
        ],
        image: {},
        content: null,
        currentContent: {},
        currentContentId: null,
        addingContent: false,
        loadingContent: false,
        loadingSchemas: false,
        dialog: false,
        html: '',
        uploadingImage: false,
        currentDelete: () => {},
      }
    },
    computed: {
      site: function () {
        return this.$store.state.site
      }
    },
    mounted () {
      this.getSchemas()
    },
    methods: {
      moment,
      getContent (schema) {
        this.selectedSchema = schema

        this.loadingContent = true
        this.api.get('content/' + schema.schemaId)
          .then(result => {
            var entries = result.data
            var content = []
            entries.forEach(entry => {
              console.log(entry)
              content.push({
                name: entry.answers.title ? entry.answers.title : entry.answers.name,
                sub1: this.moment(entry.created).format('DD-MM-YY HH:mm'),
                image: entry.answers.image ? entry.answers.image : '',
                answers: entry.answers,
                id: entry.contentId
              })
            })
            console.log(content)
            this.content = content
            this.loadingContent = false
          }, error => {
            this.loadingContent = false
            this.error = error
          })
      },
      getSchemas () {
        this.loadingSchemas = true
        this.api.get('content/schemas/' + this.site)
          .then(result => {
            var schemas = result.data
            schemas.forEach(schema => {
              schema.sub1 = this.moment(schema.created).format('DD-MM-YY')
            })
            this.schemas = schemas
            this.loadingSchemas = false
          }, error => {
            this.loadingSchemas = false
            this.error = error
          })
      },
      addContent () {
        if (this.currentContentId) {
          this.resetContent()
        }
        this.dialog = true
      },
      editContent (content) {
        this.resetContent()
        this.currentContentId = content.id
        this.currentContent = content.answers
        this.dialog = true
      },
      resetContent () {
        this.currentContentId = null
        this.currentContent = {}
        this.image = {}
      },
      saveContent () {
        if (this.$refs.form.validate()) {
          this.addingContent = true
          var route = 'content/' + this.selectedSchema.schemaId
          if (this.currentContentId) {
            route += '/' + this.currentContentId
          }
          this.api[this.currentContentId ? 'put' : 'post'](route, this.currentContent)
            .then(result => {
              this.getContent(this.selectedSchema)
              this.addingContent = false
              this.dialog = false
              this.resetContent()
            })
            .catch(error => {
              this.error = error
              this.addingContent = false
            })
        }
      },
      deleteContent (content, done) {
        this.api.delete('content/' + this.selectedSchema.schemaId + '/' + content.id)
          .then(result => {
            this.getContent(this.selectedSchema)
            done()
          }, error => {
            done()
            this.error = error
          })
      },
      onContentDelete (content) {
        this.currentDelete = (done) => this.deleteContent(content, done)
        this.$refs.yesno.open(`Delete ${content.name}`, `Are you sure you want to delete ${content.name} from ${this.selectedSchema.name}?`)
      },
      uploadImage (fieldName) {
        var formData = new FormData()
        formData.append('file', this.image[fieldName])

        this.uploadingImage = true

        this.api.post('file/' + this.site, formData)
          .then(result => {
            this.currentContent[fieldName] = result.data
            this.uploadingImage = false
          })
          .catch(error => {
            this.error = error
            this.uploadingImage = false
          })
      },
      handleImageAdded: function (image, Editor, cursorLocation, resetUploader) {
        var formData = new FormData()
        formData.append('file', image)

        this.uploadingImage = true

        this.api.post('file/' + this.site, formData)
          .then(result => {
            const url = result.data
            Editor.insertEmbed(cursorLocation, 'image', url)
            resetUploader()
            this.uploadingImage = false
          })
          .catch(error => {
            this.error = error
            this.uploadingImage = false
          })
      }
    }

  }
</script>
